export default __webpack_public_path__ + "static/media/pending.ad8f9456.jpg";